import React, { useState, useEffect, useRef } from "react";
import { getData } from "app/data";
import SoftwareSolution from "components/SoftwareSolution";
import PageHeader from "components/PageHeader/TitleSubtitlePageHeader";
import CommonUseCases from "components/CommonUseCases"
import WaitingFor from "components/Banner/WaitingFor";
import { useSmoothScroll } from 'components/Main/pages/MerchantService/useSmoothScroll.js';

export default function Index() {
  const { myRef, clickHandle } = useSmoothScroll();
  const [activeBtn, setActiveBtn] = useState();
  useEffect(() => {
    let urlArr = window.location.pathname.split("/");
    if (urlArr.includes("software-solution")) {
      setActiveBtn(true);
    } else if (urlArr.includes("software-solution-kiosk")) {
      setActiveBtn(false);
    }
  }, []);
  return (
    <div className="software-solution-page">
      <PageHeader
        title="software_solution"
        subtitle="software_sec_header_desc"
        subtitle2="kiosk_title"
        subtitleColorGreen={true}
        activeBtn={activeBtn}
        clickHandle={clickHandle}
      />
      <hr />
      <div ref={myRef} />
      <SoftwareSolution data={getData("softwareSolution")} />
      <CommonUseCases data="useCaseData" />
      <WaitingFor />
    </div>
  );
}
